import {takeEvery} from 'redux-saga/effects'
import {
  SP_MISC_GET_CHILD_PROFILE,
  SP_MISC_GET_NEWS_APPROVAL_OTP,
  SP_MISC_GET_NOTIFICATION_DETAIL,
  SP_MISC_GET_OWN_PROFILE,
  SP_MISC_GET_PARENTING_WELCOME,
  SP_MISC_GET_PRO_UPGRADE,
  SP_MISC_GET_SCHOOL_BLOG_POST,
  SP_MISC_GET_SCHOOL_BLOG_POSTS,
  SP_MISC_POST_SCHOOL_BLOG_COMMENT,
  SP_MISC_SEND_NEWS_APPROVAL_OTP,
  SP_MISC_SEND_PARENTING_CONTACT,
  SP_MISC_VERIFY_NEWS_APPROVAL_OTP,
} from 'setup/redux/Actions/SpMisc/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

/** Routes every student/parent misc-screen request through the shared fetch worker. */
function* spMiscSagas() {
  yield takeEvery(SP_MISC_GET_SCHOOL_BLOG_POSTS, fetchData)
  yield takeEvery(SP_MISC_GET_SCHOOL_BLOG_POST, fetchData)
  yield takeEvery(SP_MISC_POST_SCHOOL_BLOG_COMMENT, fetchData)
  yield takeEvery(SP_MISC_GET_NOTIFICATION_DETAIL, fetchData)
  yield takeEvery(SP_MISC_GET_NEWS_APPROVAL_OTP, fetchData)
  yield takeEvery(SP_MISC_SEND_NEWS_APPROVAL_OTP, fetchData)
  yield takeEvery(SP_MISC_VERIFY_NEWS_APPROVAL_OTP, fetchData)
  yield takeEvery(SP_MISC_GET_PRO_UPGRADE, fetchData)
  yield takeEvery(SP_MISC_GET_PARENTING_WELCOME, fetchData)
  yield takeEvery(SP_MISC_SEND_PARENTING_CONTACT, fetchData)
  yield takeEvery(SP_MISC_GET_CHILD_PROFILE, fetchData)
  yield takeEvery(SP_MISC_GET_OWN_PROFILE, fetchData)
}

export default spMiscSagas
